import React, { useCallback } from 'react';
import { KeyRound } from 'lucide-react';
import SignInOptions from '../../components/SignInOptions';

// /signin-phone — a computer signs in without a password (docs/OL_ACCESS_LINKS.md §3a + §11): approved from a
// family phone (code + QR) or with a one-time code emailed to the address on file. Remembered afterwards.
export default function PhoneSignInPage() {
  const done = useCallback((next) => window.location.replace(next || '/dashboard'), []);
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex items-center justify-center p-4" data-testid="phone-signin-page">
      <div className="max-w-md w-full rounded-xl border bg-white dark:bg-slate-800 dark:border-slate-700 p-6 text-center space-y-4">
        <KeyRound className="h-8 w-8 mx-auto text-slate-500" />
        <h1 className="text-xl font-bold">Sign in without a password</h1>
        <SignInOptions onSignedIn={done} />
      </div>
    </div>
  );
}
